import { styled, keyframes } from 'goober';

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export const Loading = styled('div')<{ $size?: number; $color?: string }>(({ theme, $size = 1, $color }) => ({
    border: `3px solid ${theme.borderColor}`,
    borderTop: `3px solid ${$color ?? theme.colors.ui.dark}`,
    borderRadius: '50%',
    width: `${20 * $size}px`,
    height: `${20 * $size}px`,
    animation: `${spin} 2s linear infinite`,
    position: 'absolute',
}));

export const LoadingOverlay = styled('div')<{ $dimBg?: boolean; $dimBgLight?: boolean }>(
    ({ theme, $dimBg, $dimBgLight }) => ({
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        left: 0,
        top: 0,
        zIndex: theme.zIndex.LOADING_APP,
        backgroundColor: $dimBg ? ($dimBgLight ? 'rgba(255, 255, 255, 0.3)' : 'rgb(0, 0, 0, 0.3)') : 'transparent',
    })
);
